// src/pages/Users/Galleries/components/SkeletonAlbumCard.jsx
import React from "react";

export default function SkeletonAlbumCard() {
  return (
    <div className="rounded-2xl overflow-hidden bg-white/70 dark:bg-slate-900/50 ring-1 ring-slate-200/70 dark:ring-slate-800/70 animate-pulse">
      <div className="w-full bg-slate-200 dark:bg-slate-800" style={{ aspectRatio: "16 / 9" }} />
      <div className="p-4 space-y-3">
        <div className="h-4 w-2/3 bg-slate-200 dark:bg-slate-800 rounded" />
        <div className="h-3 w-full bg-slate-200 dark:bg-slate-800 rounded" />
        <div className="h-3 w-5/6 bg-slate-200 dark:bg-slate-800 rounded" />
        <div className="h-8 w-32 bg-slate-200 dark:bg-slate-800 rounded mt-2" />
      </div>
    </div>
  );
}
